import { render, staticRenderFns } from "./PopupMessengersPush.vue?vue&type=template&id=6334e7b1"
import script from "./PopupMessengersPush.vue?vue&type=script&lang=js"
export * from "./PopupMessengersPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports